module.exports = __webpack_public_path__ + "static/LogoKlebLockOriginal-d2a32709411c0407ed5421dbc5fcaf72.png";